export const actions = {
  SEND_EMAIL: "SEND_EMAIL",
  EMAIL_CHANGE: "EMAIL_CHANGE",
  EMAIL_RECOVERY: "EMAIL_RECOVERY"
};

export function sendEmail(email: string) {
  return {
    type: actions.SEND_EMAIL,
    email
  };
}

export function emailChange() {
  return {
    type: actions.EMAIL_CHANGE
  };
}

export function emailRecovery() {
  return {
    type: actions.EMAIL_RECOVERY
  };
}
